var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._g(_vm._b({},'v-container',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.langs),function(langPim,lang){return _c('div',{key:langPim},[(_vm.hasValue(_vm.value, langPim))?_c('flag',{attrs:{"iso":lang}}):_vm._e(),_vm._v(" "+_vm._s(_vm.getValue(_vm.value, langPim))+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }